import { Link } from "react-router-dom";
const About = () => {
    return (
        <>

            <h1> About</h1>
            <p>Compassionate and Professional Credit Repair Services
                YOUR CREDIT CAN HAVE A HEALTHY SECOND LIFE.
                THAT’S WHY WE’RE HERE.
            </p>
        </>
    )
}

export default About;